import { ErrorHandler, Injectable } from "@angular/core";
import { HttpService } from "../services/http.service";
import { stringify } from "@angular/compiler/src/util";
import { NotificationService } from "../services/notification.service";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private httpService: HttpService,
    private notificationService: NotificationService
  ) {}

  handleError(error: ErrorEvent): void {
    console.log(error);
    // console.log(error.message);
    // error = stringify(error);
    // console.log(error.message.indexOf('ExpressionChangedAfterItHasBeenCheckedError'));
    // console.log(error);
    if (
      error.message &&
      error.message.indexOf("ExpressionChangedAfterItHasBeenCheckedError") ===
        -1
    ) {
      console.error(error);
      // this.notificationService.log("Error: " + JSON.stringify(error));
      // this.httpService.openErrorDialog(this.httpService.appErrorMessage);
    }
    // this.httpService.openErrorDialog(this.httpService.appErrorMessage);
    //throw new Error("Method not implemented.");
  }
}
